/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ e: NonNullable<unknown> }} Variable_Details_Copy_ErrorInputs */



/**
* | output |
* | --- |
* | "An error occurred while copying the variables: {e}" |
*
* @param {Variable_Details_Copy_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const variable_details_copy_error = /** @type {((inputs: Variable_Details_Copy_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Variable_Details_Copy_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`An error occurred while copying the variables: ${i?.e}`)
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors de la copie des variables : ${i?.e}`)
});